import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(219, 234, 254, 0.5) 0%,
    rgba(243, 232, 255, 0.5) 100%
  );
  width: max-content;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  /* padding-bottom: 0; */
  margin-bottom: 24px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
    transition: background 0.2s ease;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: rgba(108, 117, 125, 0.6);
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(108, 117, 125, 0.8);
    }
  }

  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &:hover {
    scrollbar-color: rgba(108, 117, 125, 0.6) transparent;
  }
`;

export const Tab = styled.button`
  position: relative;
  width: 105px;
  height: 30px;
  background-color: ${({ $active }) => ($active ? '#ffffff' : 'transparent')};
  padding: 0;
  border: none;
  border-radius: 14px;
  color: #000000;
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  white-space: nowrap;
  box-shadow: ${({ $active }) =>
    $active
      ? '0px 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)'
      : 'none'};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    opacity: ${({ disabled }) => (disabled ? '0.5' : '0.9')};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const AssignmentSummarySection = styled.div`
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const SummaryTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

export const SummaryContent = styled.div`
  margin-top: 8px;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
`;

export const SummaryLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  min-width: 80px;
`;

export const SummaryTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
`;

export const SummaryTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background-color: #eff6ff;
  color: #1e40af;
  font-size: 13px;
  border-radius: 4px;
  border: 1px solid #bfdbfe;
  border-radius: 20px;

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    color: #1e40af;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const EmptyState = styled.div`
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
`;

export const HintText = styled.div`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
`;

export const ModalFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
